import GraphState from './../rappid/graph-state'

import { useRouteStore } from '@/stores/routeStore'
import { useTraceDataStore } from '@/stores/traceDataStore'

import { Artifact } from '@/models/artifact.model'

import { useCellSelection } from './cell-selection'
import { EventBus } from '@/event-bus'
import { useHelpers } from './helpers'
import { ArtifactType, asSnapshotReference } from '@/models'
import { parseIntUndefined } from '@/utils/helpers'
import { injectTyped } from '@/inject'
import { ServiceKeys } from '@/services/symbols'

export function useRegisterElementDoubleClickEvent() {
  const rappidContext = injectTyped(ServiceKeys.rappidContext)
  const artifactService = injectTyped(ServiceKeys.artifact)

  const routeStore = useRouteStore()
  const traceDataStore = useTraceDataStore()

  const { highlightDirectLinks } = useCellSelection()

  const { getArtifactFromElementView, getArtifactTypeFromCellView } = useHelpers()

  async function fetchLinks(cellView: joint.dia.CellView): Promise<void> {
    const cell = cellView.model
    if (cell.prop(GraphState.PROP_ARTIFACT)) {
      rappidContext.paper.requireView(cell)
      const artifact = cell.prop(GraphState.PROP_ARTIFACT) as Artifact
      if (routeStore.projectId && routeStore.snapshotId) {
        await traceDataStore.updateTraceDataFromApi({
          artifactService: artifactService,
          projectId: parseInt(routeStore.projectId),
          snapshotId: asSnapshotReference(routeStore.snapshotId),
          filterId: parseIntUndefined(routeStore.filterId),
          id: artifact.id,
          direction: 'any',
        })
      }

      EventBus.emit('traceModelStateChanged')

      if (traceDataStore.highlightAllDirectLinksOnSelection) {
        highlightDirectLinks(cellView as joint.dia.ElementView)
      }
    }
  }

  function toggleContainerCollapse(artifactType: ArtifactType, cellView: joint.dia.CellView): void {
    EventBus.emit('updateContainerToggleCollapse', { artifactType, cellView })
  }

  function registerElementDoubleClickEvent() {
    rappidContext.paper.on(
      'cell:pointerdblclick',
      (cellView: joint.dia.CellView /*, evt: any, x: number, y: number */) => {
        if (cellView.model.get('isPill')) return
        const artifact = getArtifactFromElementView(cellView as joint.dia.ElementView)
        const artifactType = getArtifactTypeFromCellView(cellView)

        if (artifact !== undefined) {
          fetchLinks(cellView)
        }

        if (artifactType !== undefined) {
          toggleContainerCollapse(artifactType, cellView.model as any as joint.dia.CellView)
        }
      },
    )
  }

  return { registerElementDoubleClickEvent, toggleContainerCollapse }
}
